import { render, staticRenderFns } from "./cuentas.vue?vue&type=template&id=f47b02dc"
import script from "./cuentas.vue?vue&type=script&lang=js"
export * from "./cuentas.vue?vue&type=script&lang=js"
import style0 from "./cuentas.vue?vue&type=style&index=0&id=f47b02dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports